'use client';

import { useRouter, usePathname } from 'next/navigation';
import { languages } from '@/lib/i18n/config';

export default function LanguageSelector() {
  const router = useRouter();
  const pathname = usePathname();
  const pathParts = pathname.split('/').filter(Boolean);

  // 当前语言
  let currentLang = pathParts[0] || 'en';
  // 当前游戏ID
  let currentGameId = undefined;

  // 处理不同的路径格式
  if (pathParts[0] === 'games') {
    // 如果是 /games/[gameId] 格式
    currentLang = 'en';
    currentGameId = pathParts[1];
  } else if (pathParts.length === 1) {
    // 如果是 /[gameId] 格式
    if (languages.some(lang => lang.code === pathParts[0])) {
      currentLang = pathParts[0];
    } else {
      currentLang = 'en';
      currentGameId = pathParts[0];
    }
  } else if (pathParts.length === 2) {
    // 如果是 /[lang]/[gameId] 格式
    currentLang = pathParts[0];
    currentGameId = pathParts[1];
  }

  const handleLanguageChange = (newLang: string) => {
    if (newLang === currentLang) return;
    
    // 根据当前状态生成新的URL
    if (currentGameId) {
      // 如果是游戏页面
      if (newLang === 'en') {
        router.push(`/${currentGameId}`);
      } else {
        router.push(`/${newLang}/${currentGameId}`);
      }
    } else {
      // 如果是主页
      if (newLang === 'en') {
        router.push('/');
      } else {
        router.push(`/${newLang}`);
      }
    }
  };

  return (
    <div className="relative">
      <select
        value={currentLang}
        onChange={(e) => handleLanguageChange(e.target.value)}
        className="block pl-3 pr-10 py-2 text-sm border border-gray-300 rounded-md 
                   focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500
                   bg-white cursor-pointer"
      >
        {languages.map(({ code, name }) => (
          <option key={code} value={code}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
}